import React from 'react';
import { chatIconTile } from './chat-theme';

/** A chat card's title row: the icon tile says what kind of card it is, the title what it's about. */
export default function CardHeader({ icon: Icon, tone = 'planning', title, meta, className = 'mb-3', children }) {
    return (
        <div className={`flex items-center gap-2.5 ${className}`}>
            {Icon && <span className={chatIconTile(tone)}><Icon aria-hidden="true" className="h-4 w-4" /></span>}
            <span className="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-2">
                <span className="text-[0.875rem] font-semibold text-gray-900">{title}</span>
                {meta && <span className="text-xs text-gray-500">{meta}</span>}
            </span>
            {children}
        </div>
    );
}
